import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Snackbar,
  Alert,
  Paper,
  InputAdornment,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import axios from "axios";
import logo from "../../Assets/logo.png";

const EnquiryFormPage = () => {
  const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    mobile: "",
    zip: "",
  });

  const [loading, setLoading] = useState(false);
  const [snack, setSnack] = useState({ open: false, severity: "info", message: "" });

  const handleChange = (e) => {
    let { name, value } = e.target;

    // Allow only numbers for mobile & ZIP
    if (name === "mobile") {
      value = value.replace(/\D/g, ""); // Remove alphabets

      if (value.length > 10) return; // Max 10 digits
    }

    if (name === "zip") {
      value = value.replace(/\D/g, ""); // Only numbers
      if (value.length > 5) return; // Max 5 digits
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Final client-side validation
    if (formData.mobile.length !== 10) {
      return setSnack({
        open: true,
        severity: "error",
        message: "Mobile number must be exactly 10 digits.",
      });
    }

    if (formData.zip.length !== 5) {
      return setSnack({
        open: true,
        severity: "error",
        message: "ZIP code must be exactly 5 digits.",
      });
    }

    setLoading(true);

    const payload = {
      business: "e3896a07-6db2-4e91-a48f-9a25a9d07e9d",
      source: "facebook",
      fname: formData.fname,
      lname: formData.lname,
      mobile: formData.mobile, // 👍 only 10 digits (NO "+1")
      zip: formData.zip,
    };

    try {
      await axios.post(
        "https://btownclinic.com/marketing_leads_backend/enquiry/create/",
        payload
      );

      setSnack({
        open: true,
        severity: "success",
        message: "Enquiry Submitted Successfully we will connect with you shortly!",
      });

      setFormData({
        fname: "",
        lname: "",
        mobile: "",
        zip: "",
      });
    } catch (error) {
      setSnack({
        open: true,
        severity: "error",
        message: error?.response?.data?.message || "Something went wrong!",
      });
    }

    setLoading(false);
  };

  return (
    <Box
      sx={{
        minHeight: "96vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #f3faff, #dbeeff)",
        padding: 2,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          width: "100%",
          maxWidth: 450,
          padding: 4,
          borderRadius: 4,
          textAlign: "center",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          <img
            src={logo}
            alt="logo"
            style={{ width: 80, height: 80, borderRadius: "50%" }}
          />
        </Box>

        <Typography variant="h5" fontWeight={600} mb={2}>
          Enquiry Form
        </Typography>

        <Typography variant="body2" color="text.secondary" mb={3}>
          Please fill out your details. Our team will contact you shortly.
        </Typography>

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            required
            label="First Name"
            name="fname"
            value={formData.fname}
            onChange={handleChange}
            margin="normal"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon color="primary" />
                </InputAdornment>
              ),
            }}
          />

          <TextField
            fullWidth
            required
            label="Last Name"
            name="lname"
            value={formData.lname}
            onChange={handleChange}
            margin="normal"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon color="primary" />
                </InputAdornment>
              ),
            }}
          />

          {/* Mobile Number */}
          <TextField
            fullWidth
            required
            label="Mobile Number"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange}
            margin="normal"
            inputProps={{ maxLength: 10 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Typography fontWeight={600} color="primary">
                    +1
                  </Typography>
                </InputAdornment>
              ),
            }}
          />

          {/* ZIP Code */}
          <TextField
            fullWidth
            required
            label="ZIP Code"
            name="zip"
            value={formData.zip}
            onChange={handleChange}
            margin="normal"
            inputProps={{ maxLength: 5 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LocationOnIcon color="primary" />
                </InputAdornment>
              ),
            }}
          />

          <Button
            fullWidth
            variant="contained"
            type="submit"
            disabled={loading}
            sx={{
              mt: 3,
              py: 1.3,
              fontSize: "16px",
              fontWeight: 600,
              borderRadius: 3,
            }}
          >
            {loading ? "Submitting..." : "Submit Enquiry"}
          </Button>
        </form>
      </Paper>

      {/* Snackbar */}
      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack({ ...snack, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={snack.severity} variant="filled">
          {snack.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default EnquiryFormPage;
